import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsTakingSchemeScreenshot } from '@pages/schemes/store/selectors';
import { setIsTakingScreenshot } from '@pages/schemes/store';

const useIsTakingSchemeScreenshot = () => {
    const dispatch = useDispatch();
    const isTakingSchemeScreenshot = useSelector(selectIsTakingSchemeScreenshot);

    const setIsTakingSchemeScreenshot = useCallback(
        (newValue) => {
            dispatch(setIsTakingScreenshot(newValue));
        },
        [dispatch],
    );

    return { isTakingSchemeScreenshot, setIsTakingSchemeScreenshot };
};

export default useIsTakingSchemeScreenshot;
